export default {"src":"/_next/static/media/TBank.cd1f6a9f.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};